<template>
	<LayoutList>
		<template slot="header">
			<img
                :src="resource.country.flag || '//placehold.it/32x21'"
                :alt="resource.country.name"
                class="flag"
                v-tippy="resource.country.name"
            />
			<h1>{{ resource.name || '&nbsp;' }}</h1>
            <router-link
                :to="{ name: 'edit-member-form', params: { id: resource.id } }"
                class="btn btn--primary"
                v-if="resource.can.edit"
            >
                Edit
            </router-link>
			<ul class="grid post-details">
				<li v-if="resource.phone" class="col-12 col-md-2 col-bleed-y detail">
					<span class="label">Telephone</span>
					<a :href="'tel:' + resource.phone"><SvgIcon :icon="'phone'" />{{ resource.phone }}</a>
				</li>
				<li v-if="resource.website" class="col-12 col-md-2 col-bleed-y detail">
					<span class="label">Website</span>
					<a :href="sanitizeUrl(resource.website)" target="_blank">
                        <SvgIcon :icon="'link'" />Website
                    </a>
				</li>
			</ul>
        </template>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="people" title="People">
				<GridUsers :filters="peopleFilters" />
			</v-tab>
			<v-tab id="opportunities" title="Opportunities">
				<div class="toolbar">
					<fieldset class="toolbar__filters">
						<div class="flex-fix">
							<FormControlSector
                                name="sectors"
                                v-model="oppFilters.sectors"
                                :multiple="true"
                                :include-ancestors="false"
                            />
							<FormControlDealType name="dealType" v-model="oppFilters.dealType" />
						</div>
					</fieldset>
					<fieldset class="toolbar__search">
						<div class="flex-fix">
							<div class="form__group search">
								<label for="opp-search" class="form__label">Search Opportunities</label>
								<input
                                    id="opp-search"
                                    class="form__control search"
                                    type="search"
                                    placeholder="Search Opportunities..."
                                    v-model="oppFilters.query"
                                />
							</div>
						</div>
					</fieldset>
				</div>
				<ListOpportunities
                    ref="opportunities"
                    :load-on-start="false"
                    :filters="oppFilters"
                />
			</v-tab>
			<v-tab id="madds" title="MADDs">
				<div class="toolbar">
					<fieldset class="toolbar__filters">
						<div class="flex-fix">
							<FormControlSector
                                name="sectors"
                                v-model="maddFilters.sectors"
                                :multiple="true"
                                :include-ancestors="false"
                            />
							<FormControlDealType
                                name="dealType"
                                v-model="maddFilters.dealType"
                            />
						</div>
					</fieldset>
					<fieldset class="toolbar__search">
						<div class="flex-fix">
							<div class="form__group search">
								<label for="madd-search" class="form__label">Search Opportunities</label>
								<input
                                    id="madd-search"
                                    class="form__control search"
                                    type="search"
                                    placeholder="Search MADDs..."
                                    v-model="maddFilters.query"
                                />
							</div>
						</div>
					</fieldset>
				</div>
				<ListMADDs
                    ref="madds"
                    :load-on-start="false"
                    :filters="maddFilters"
                />
			</v-tab>

			<v-tab id="insights" title="Insights">
				<div class="toolbar">
					<fieldset class="toolbar__filters">
						<div class="flex-fix">
							<FormControlSector
                                name="sectors"
                                v-model="insFilters.sectors"
                                :multiple="true"
                                :include-ancestors="false"
                            />
						</div>
					</fieldset>
					<fieldset class="toolbar__search">
						<div class="flex-fix">
							<div class="form__group search">
								<label for="int-search" class="form__label">Search Insights</label>
								<input
                                    id="int-search"
                                    class="form__control search"
                                    type="search"
                                    placeholder="Search Insights..."
                                    v-model="insFilters.query"
                                />
							</div>
						</div>
					</fieldset>
				</div>
				<ListInsights
                    ref="insights"
                    :load-on-start="false"
                    :filters="insFilters"
                />
			</v-tab>
		</vue-tabs>
	</LayoutList>
</template>
<script>
	import API from './../../api';
	import LayoutList from './../Layout/LayoutList';
	import GridUsers from './../Grid/GridUsers';
	import ListOpportunities from './../List/ListOpportunities';
	import ListMADDs from './../List/ListMADDs';
	import ListIntelligence from './../List/ListIntelligence';
	import ListInsights from './../List/ListInsights';
	import FormControlDealType from './../Form/Control/FormControlDealType';
	import FormControlSector from './../Form/Control/FormControlSector';
	import SvgIcon from '../SvgIcon';
	import TabbedPage from '../TabbedPage';
	import ResourceView from '../ResourceView';

	export default {
		name: 'MemberView',
		mixins: [TabbedPage, ResourceView],
		components: {
			SvgIcon,
			LayoutList,
			GridUsers,
			ListOpportunities,
			ListMADDs,
			ListIntelligence,
			ListInsights,
			FormControlDealType,
			FormControlSector
		},
		data() {
			return {
				resource : {
					name: '',
					phone: '',
					website: '',
					country: {
						flag: '',
						name: '',
					}
				},
				peopleFilters: {
					member: this.id,
					query: null,
				},
				oppFilters: {
					type: null,
					sectors: [],
					dealType: null,
					member: this.id,
					query: null,
				},
				maddFilters: {
					sectors: [],
					dealType: null,
					member: this.id,
					query: null,
				},
				intFilters: {
					sectors: [],
					dealType: null,
					member: this.id,
					query: null,
				},
				insFilters: {
					sectors: [],
					dealType: null,
					member: this.id,
					query: null,
				},
				defaultTab: 'people',
				tabRoute: 'view-member',
			}
		},
        watch: {
            id: function (newVal, oldVal) {
                return API.getMember(newVal)
                    .then(response => {
                        console.log("[MemberView.vue] - ", response);
                        this.resource = response;
                        this.peopleFilters.member = newVal;
                        this.oppFilters.member = newVal;
                        this.maddFilters.member = newVal;
                        this.intFilters.member = newVal;
                        this.insFilters.member = newVal;
                    });
            }
        },
		methods: {
            stepLink() {
                return { name: 'edit-member-step', params: { step: 1, id: this.id }}
            },
			fetchResource() {
				return API.getMember(this.id);
			},
			//TODO: Move to backend
			sanitizeUrl(url) {
				if(url.indexOf('http') < 0 && url.indexOf('https') < 0 ){
					url = 'http://' + url;
				}

				return url;
			}
		}
	}
</script>
